// extracted by mini-css-extract-plugin
module.exports = {"root":"ellipsis_root__huVcQ"};